
import React, { useEffect } from 'react';
import { Route, Redirect, useLocation, matchPath, useRouteMatch, match } from "react-router-dom";
import { matchRoutes } from 'react-router-config';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import RoutesConfig from 'router';
import {
  featureToggle
} from 'components/ACL/FeatureToggle';
import ReactRouterContext from 'contexts/ReactRouterContext'
import BasicConfig from 'config/basic/config.json';
// import Languages from 'locales';

const permissionType:any = BasicConfig.basic.permissionType.value;
const basicRouter:any = RoutesConfig.find((route:any) => route.path == '/');
// const projectRoute:any = basicRouter.routes.filter((route:any) => route.isProject).map((route:any) => `(${route.path})`)
const firstRouter:any = basicRouter.routes.filter((route:any) => route.path !== '/404' && route.path !== '/account')[0];
const enableFeatureAcl: any = BasicConfig.basic.enableFeatureAcl.value;
const enableVerifyToken:any = BasicConfig.basic.enableVerifyToken.value;

export const Routes = (props:any) => {
  const { userInfo, moduleAcl = {}, rootPath, langRoutes } = props;
  const installedUserModule = RoutesConfig.map((route:any) => route.path).indexOf('/user') >= 0;
  const accountAuth:any = JSON.parse(localStorage.getItem('account-auth') || '[]') || {};
  const isUserLogined:boolean = accountAuth && accountAuth?.token;
  const location = useLocation();
  const roles:any =  userInfo?.roles || {};
  let allowRoutes: string[] = [];
  const meta = useSelector((state:any) => state.global.meta);
  const configAclSet: any = useSelector((state: any) => state.global.featureAcl);
  const apiAclSet = meta.data.features || [];
  // const LangsKeys = _.values(Languages);
  // const langPathRegex = LangsKeys.length > 1 ? _.chain(LangsKeys).reduce((a,b) => a.keys +  `|${b.keys}`).value() : LangsKeys[0].keys;

  const matchRootPath:any = matchPath(location.pathname, {
    path: rootPath,
    exact: true,
    strict: true
  });

  const getUserAcl = () => {
    let userAcl:any = [];
    if(permissionType == 'role') {
      userAcl = roles[userInfo.current] || [];
    } else if(permissionType == 'acl') {
       Object.keys(roles).forEach((key:any) => {
        userAcl = [...roles[key], ...userAcl]
      })
    }
    return _.uniq(userAcl)
  }; 

  // const paths:string[] = []
  /* let langRoutes = _.cloneDeep(props.routes);
  langRoutes = _.chain(langRoutes)
  .reverse()
  .filter((item:any) => {
    const addLangPath = (route:any) => {
      route.path = [route.path.replace(new RegExp(projectRoute.join(''), 'g'),'') || `/`, `/:lang(|${langPathRegex})${route.path.replace(new RegExp(projectRoute.join(''), 'g'),'')}`];
      if(paths.indexOf(route.path[0]) < 0) {
        (route.routes || []).map((subRoute:any) => {
          return addLangPath(subRoute);
        })
        paths.push(route.path[0])
        return route;
      }
    }
    return addLangPath(item)
  }).value(); */

  const matchedRoutes = langRoutes && matchRoutes(langRoutes, location.pathname) ||[];
  const existRoute:any = matchedRoutes.find((item:any) => item.match.isExact);
  const isExistRoute:any = !!existRoute;
  

  const RouteWithSubRoutes = (route:any, index:any) => {
    const RouteComponent:any = route.component ? props.routeComponents[route.component]: false;
    const matchRouteItem:any = matchPath(location.pathname, {
      path: route.path,
      exact: true,
      strict: true
    });

    return (
      <React.Fragment
        key={index}
      >
        <Route
          key={index}
          path={route.path}
          exact
          render={props => {
            return  route.component && RouteComponent ? (<ReactRouterContext><RouteComponent {...props} {...route}/></ReactRouterContext>) : <></>
          }}
          
        />
        {
          route.routes && route.routes.map((child:any, i:any) => {
            const id = child.path[0];
            if(enableFeatureAcl && !featureToggle(id, configAclSet, apiAclSet)) return false;
             
            const idAcl:any = moduleAcl[child.path[0]] || [];
            const permission:any = _.intersection(idAcl, getUserAcl());

            if (!moduleAcl[child.path[0]] || (moduleAcl[child.path[0]] && permission.length > 0 || permissionType == 'none')) {
              child.path.map((path:string) => {
                allowRoutes.push(path);
              })
              return RouteWithSubRoutes(child,i);
            }
          })
        }
        {
          matchRouteItem && matchRouteItem.isExact && (typeof route.redirect === 'object' && Object.keys(route.redirect).length > 0 || route.redirect) &&
          <Redirect to={`${matchRouteItem.params.lang ? `/${matchRouteItem.params.lang}`: ''}${route.redirect[userInfo.current] || route.redirect || '/404'}`}/>
        }
      </React.Fragment>
      
    );
  }

  return (
    <>
      {
        (langRoutes || []).map((route:any, index:number) => {
          const id = route.path[0];
          if(enableFeatureAcl && !featureToggle(id, configAclSet, apiAclSet)) return false;
          const idAcl:any = moduleAcl[route.path[0]] || [];
          const permission:any = _.intersection(idAcl, getUserAcl());
          if (route.path.filter((path:string) => path.match('style')).length >= 0 || !moduleAcl[route.path[0]] || (moduleAcl[route.path[0]] && permission.length > 0 || permissionType == 'none') ) {
            route.path.map((path:string) => {
              allowRoutes.push(path);
            })
            return RouteWithSubRoutes(route,index)
          }
        })
      }
      {
        (enableVerifyToken && installedUserModule && !isUserLogined || !enableVerifyToken) && (typeof props.redirect === 'string' && props.redirect || typeof props.redirect === 'object' && Object.keys(props.redirect || '').length > 0) && matchRootPath && matchRootPath.isExact && matchRootPath.params.lang !='404' &&
        <Redirect from="/" to={typeof props.redirect === 'string' ? `${matchRootPath.params.lang ? `/${matchRootPath.params.lang}` : ''}${props.redirect}` : props.redirect[userInfo.current] && `${matchRootPath.params.lang ? `/${matchRootPath.params.lang}` : ''}${props.redirect[userInfo.current]}` || firstRouter && firstRouter.routes.length && `${matchRootPath.params.lang ? `/${matchRootPath.params.lang}` : ''}${firstRouter.routes[0].path}` || '/404'}/>
      }
      {
        enableVerifyToken && (installedUserModule && !isUserLogined) && !location.pathname.match('/user') &&
        <Redirect to="/user/login"/>
      }
      {
       (!matchRootPath || !matchRootPath.isExact) && (!isExistRoute || allowRoutes.indexOf(existRoute.match.path) < 0) && <Redirect from='*' to={`${matchRootPath && matchRootPath.url == '/' ? installedUserModule && !isUserLogined ? '/user' : '' : matchRootPath && matchRootPath.url || ''}/404`} />
      }
      
    </>
  )
}